function Switch({ id_item, name, description, checked, handleChange, disabled }) {

    return (
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight">
                <div className="form-label_">{name}</div>
                {description !== undefined && (<small>{description}</small>)}
            </div>
            <div className="p-1 bd-highlight">
                <div className="form-check_ form-switch p-0" >
                    <div className="d-inline-flex flex-row-reverse gap-1">
                        <input key={Math.random()} defaultChecked={checked} className="form-check-input ms-0" type="checkbox" role="switch" onChange={(e) => handleChange(e.target.checked, id_item)} disabled={disabled} />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Switch;